<template>
  <div>
    <StatusBar :status="status" />

    <!-- 身份证上传区域 -->
    <div class="photo">
      <!-- 身份证正面 -->
      <div class="font">
        <img
          class="sfz1"
          :src="sfz1.data"
          :preview="(sfz1.uploaded && !$isWx) ? 0 : false"
          @click="imageControl(sfz1.type)"
          alt="身份证正面"
        />
        <p :class="{ hide: sfz1.uploaded, show: !sfz1.uploaded }">
          请拍摄本人身份证正面
        </p>
        <p
          class="pointText"
          :class="{ show: sfz1.reTake, hide: !sfz1.reTake }"
          @click="reTakeAction(sfz1.type)"
        >
          重拍
        </p>
        <input
          v-if="!$isWx"
          :class="!sfz1.uploaded ? 'upload-input' : 'upload-input re-take-input'"
          type="file"
          accept="image/*"
          :ref="sfz1.refName"
          @change="handleInputUploadImg(sfz1.type, sfz1.refName)"
        />
      </div>

      <!-- 身份证反面 -->
      <div class="back">
        <img
          class="sfz2"
          :src="sfz2.data"
          @click="imageControl(sfz2.type)"
          :preview="(sfz2.uploaded && !$isWx) ? 0 : false"
          alt="身份证反面"
        />
        <p :class="{ hide: sfz2.uploaded, show: !sfz2.uploaded }">
          请拍摄本人身份证反面
        </p>
        <p
          class="pointText"
          :class="{ show: sfz2.reTake, hide: !sfz2.reTake }"
          @click.stop="reTakeAction(sfz2.type)"
        >
          重拍
        </p>
        <input
          v-if="!$isWx"
          :class="!sfz2.uploaded ? 'upload-input' : 'upload-input re-take-input'"
          type="file"
          accept="image/*"
          :ref="sfz2.refName"
          @change="handleInputUploadImg(sfz2.type, sfz2.refName)"
        />
      </div>
    </div>

    <!-- 示例按钮 -->
    <div class="tsBtnBg" @click="tsControl(true)">
      <span class="tsIcon" />
      <span class="tsBtn">点击查看示例</span>
    </div>

    <!-- 示例弹窗 -->
    <div v-if="tsShow" class="tsBg" @click="tsControl(false)">
      <div class="tsContent" @click.stop>
        <p>身份证正面</p>
        <img src="../../assets/tsid1.png" alt="身份证正面示例" />
        <p>身份证反面</p>
        <img src="../../assets/tsid2.png" alt="身份证反面示例" />
      </div>
      <img
        class="closeBtn"
        src="../../assets/ts_close.png"
        alt="关闭"
        @click="tsControl(false)"
      />
    </div>

    <!-- 下一步按钮 -->
    <p
      class="btn"
      :class="classObject"
      @click="nextBtnClick"
    >
      下一步
    </p>

    <!-- 拍摄示意图 -->
    <div>
      <div class="title">
        <img src="../../assets/info_left.png" alt="" />
        <p>拍摄示意图</p>
        <img src="../../assets/info_right.png" alt="" />
      </div>
      <div class="content">
        <div v-for="(item, index) in shootingExamples" :key="index">
          <span>{{ item.label }}</span>
          <img :src="item.image" :alt="item.label" />
        </div>
      </div>
    </div>

    <!-- 联系信息 -->
    <div class="info-container">
      <template v-if="defaultInfo.phone || defaultInfo.address">
        <div v-if="defaultInfo.phone">
          如有疑问请联系当地分公司：<span>{{ defaultInfo.phone }}</span>
        </div>
        <div v-if="defaultInfo.address">
          联系地址：{{ defaultInfo.address }}
        </div>
      </template>
      <div v-else class="tips">
        {{ defaultInfo.default_text }}<span>{{ defaultInfo.default }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {
  changeHistory,
  showAlertBox,
  showToast,
  showLoading,
  hideLoading
} from '../../utils/common'
import {
  uploadPic,
  wxConfig,
  checkCard,
  submitIdCard,
  getCompanyInfo,
  mRequestMonitor
} from '../../utils/actions'
import UploadUtils from '../../utils/upload'

import StatusBar from '../../components/StatusBar'

// 常量定义
const ID_FRONT_IMG = require('../../assets/id_front.png')
const ID_BACK_IMG = require('../../assets/id_back.png')
const ID_TYPES = {
  FRONT: 3,
  BACK: 4
}
const REF_NAMES = {
  FRONT: 'uploadInputFront',
  BACK: 'uploadInputBack'
}
const WX_API_LIST = [
  'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems',
  'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice',
  'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice',
  'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage',
  'downloadImage', 'getNetworkType', 'getLocalImgData', 'openLocation', 'getLocation',
  'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay',
  'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'
]

export default {
  name: 'cardIDUpLoad',
  components: {
    StatusBar
  },
  data () {
    return {
      status: '',
      sfz1: {
        type: ID_TYPES.FRONT,
        uploaded: false,
        reTake: false,
        data: ID_FRONT_IMG,
        refName: REF_NAMES.FRONT
      },
      sfz2: {
        type: ID_TYPES.BACK,
        uploaded: false,
        reTake: false,
        data: ID_BACK_IMG,
        refName: REF_NAMES.BACK
      },
      unLoadTap: false,
      tsShow: false,
      idCard: '',
      defaultInfo: {},
      shootingExamples: [
        { label: '标准', image: require('../../assets/id_1standard.png') },
        { label: '缺角', image: require('../../assets/id_2loss.png') },
        { label: '模糊', image: require('../../assets/id_3blur.png') },
        { label: '反光', image: require('../../assets/id_4reflect.png') }
      ]
    }
  },
  async created () {
    this.status = this.$route.params.status

    // 初始化微信配置
    if (this.$isWx) {
      await this.initWxConfig()
    }

    // 获取公司信息
    await this.loadCompanyInfo()

    changeHistory()
  },
  methods: {
    // 初始化微信配置
    async initWxConfig () {
      try {
        const shareUrl = location.href.split('#')[0].replace(/&/g, '%26')
        const config = await wxConfig({ shareUrl })
        const data = config.data
        data.jsApiList = WX_API_LIST
        wx.config(data)
      } catch (error) {
        showAlertBox(`微信配置初始化失败：${error.message}，请刷新页面重试`)
        mRequestMonitor({
          pageSign: 'carID-uploading',
          function: 'initWxConfig',
          errMsg: error.message
        })
      }
    },

    // 加载公司信息
    async loadCompanyInfo () {
      try {
        const res = await getCompanyInfo({
          city_id: this.$store.state.cityId
        })
        this.defaultInfo = res.data
      } catch (error) {
        showAlertBox(`公司信息获取失败：${error.message}，请刷新页面重试`)
        mRequestMonitor({
          pageSign: 'carID-uploading',
          function: 'loadCompanyInfo',
          errMsg: error.message
        })
      }
    },

    // 下一步按钮点击
    async nextBtnClick () {
      if (!this.sfz1.uploaded || !this.sfz2.uploaded) {
        return
      }

      try {
        const res = await checkCard({
          method: 'driver.signup.checkidcard',
          id: this.$store.state.id
        })

        if (!res || +res.code !== 0) {
          this.clearImage(this.sfz1.type)
          this.clearImage(this.sfz2.type)
          showAlertBox(res.message)
          return
        }

        this.$router.push({ name: 'licenceLoad', params: { status: '6' } })
      } catch (error) {
        showAlertBox(`身份证校验失败：${error.message}，请重试`)
        mRequestMonitor({
          pageSign: 'carID-uploading',
          function: 'nextBtnClick',
          errMsg: error.message
        })
      }
    },

    // 图片控制
    imageControl (type) {
      const info = this.getImageInfo(type)
      if (info.uploaded) {
        this.previewImage(info)
      } else {
        this.chooseImage(type)
      }
    },

    // 预览图片
    previewImage (info) {
      if (this.$isWx) {
        wx.previewImage({
          current: info.data,
          urls: [info.data]
        })
      }
    },

    // 重拍操作
    reTakeAction (type) {
      this.chooseImage(type)
    },

    // 清除图片
    clearImage (type) {
      const info = this.getImageInfo(type)
      const defaultImg = type === ID_TYPES.FRONT ? ID_FRONT_IMG : ID_BACK_IMG

      Object.assign(info, {
        data: defaultImg,
        uploaded: false,
        reTake: false
      })
    },

    // 获取图片信息
    getImageInfo (type) {
      return type === ID_TYPES.FRONT ? this.sfz1 : this.sfz2
    },

    // 处理文件上传
    async handleInputUploadImg (type, refName) {
      const fileData = this.$refs[refName].files[0]
      if (!fileData) return

      try {
        showLoading()
        const compressFile = await UploadUtils.compressImage(fileData, {
          quality: 0.6
        })
        const uploadResult = await UploadUtils.uploadFile(compressFile)
        hideLoading()
        await this.uploadPic(uploadResult.data, type)
      } catch (error) {
        showAlertBox(`上传失败：${error.message}，请重试`)
        mRequestMonitor({
          pageSign: 'carID-uploading',
          function: 'handleInputUploadImg',
          errMsg: error.message
        })
      }
    },

    // 选择图片（微信环境）
    chooseImage (type) {
      if (this.unLoadTap) return

      wx.chooseImage({
        count: 1,
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          this.unLoadTap = true
          wx.uploadImage({
            localId: res.localIds[0],
            isShowProgressTips: 1,
            success: (res) => {
              this.uploadPic(res.serverId, type)
            },
            fail: (error) => {
              this.unLoadTap = false
              showAlertBox(`上传失败：${JSON.stringify(error)}，请重试`)
              mRequestMonitor({
                pageSign: 'carID-uploading',
                function: 'wx.uploadImage',
                errMsg: JSON.stringify(error)
              })
            }
          })
        },
        fail: (error) => {
          showAlertBox(`图片选择失败：${JSON.stringify(error)}，请重试`)
          mRequestMonitor({
            pageSign: 'carID-uploading',
            function: 'wx.chooseImage',
            errMsg: JSON.stringify(error)
          })
        }
      })
    },

    // 上传图片
    async uploadPic (data, type) {
      const params = {
        imagename: 'myImage.png',
        city_id: this.$store.state.cityId,
        id: this.$store.state.id,
        method: 'driver.signup.upload'
      }

      params[`pic${type}_base64`] = data

      try {
        const res = await uploadPic(params)
        this.unLoadTap = false

        const info = this.getImageInfo(type)
        if (res.code !== 0) {
          showAlertBox(res.message)
          return
        }
        showToast('上传成功')
        Object.assign(info, {
          reTake: true,
          uploaded: true,
          data: res.pic
        })
        this.$previewRefresh()
        // if (res.data.id_card) {
        //   await this.submitIdCard(res.data.id_card, res.data.id)
        // }
      } catch (error) {
        this.unLoadTap = false
        showAlertBox(`上传失败：${error.message}，请重试`)
        mRequestMonitor({
          pageSign: 'carID-uploading',
          function: 'uploadPic',
          errMsg: error.message
        })
      }
    },

    // 提交身份证信息
    async submitIdCard (idCard, id) {
      try {
        await submitIdCard({
          idCard,
          recordId: id
        })
      } catch (error) {
        console.error('提交身份证信息失败:', error)
      }
    },

    // 控制示例显示
    tsControl (val) {
      this.tsShow = val
    }
  },
  computed: {
    classObject () {
      return this.sfz1.uploaded && this.sfz2.uploaded ? 'opacity' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.photo {
  text-align: center;

  div {
    position: relative;
    margin: 0 auto;
  }

  img,
  input,
  div {
    width: 3.8rem;
    height: 2.12rem;
  }

  input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  p {
    position: absolute;
    font-size: 0.24rem;
    color: #19191A;
    width: 100%;
    text-align: center;
  }

  .pointText {
    color: white;
    bottom: 0;
    opacity: 0.5;
    height: 0.48rem;
    line-height: 0.48rem;
    background: #000000;
  }

  .font {
    position: relative;
    margin-top: 0.76rem;

    p:nth-of-type(1) {
      top: 1.28rem;
    }
  }

  .back {
    position: relative;
    margin-top: 0.3rem;

    p:nth-of-type(1) {
      top: 1.2rem;
    }
  }

  .upload-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    font-size: 12px;

    &.re-take-input {
      height: 0.48rem;
      width: 3.8rem;
      bottom: 0;
      top: auto;
    }
  }
}

.btn {
  height: 0.92rem;
  width: 90%;
  margin-left: 5%;
  margin-top: 0.42rem;
  line-height: 0.92rem;
  text-align: center;
  opacity: 0.3;
  color: #ffffff;
  font-size: 0.3rem;
  border-radius: 0.04rem;
  background-image: linear-gradient(269deg, #3b414d 0%, #262a32 100%);
}

.tsBtnBg {
  text-align: center;
  font-size: 0.24rem;
  margin-top: 0.42rem;
  margin-bottom: 0.46rem;

  .tsIcon {
    position: absolute;
    top: 6.72rem;
    left: 2.5rem;
    background: url('../../assets/bar_icon_info.png') no-repeat;
    background-size: 100%;
    width: 0.3rem;
    height: 0.3rem;
  }

  .tsBtn {
    color: #737780;
    line-height: 0.25rem;
    border-bottom: 1px solid #737780;
  }
}

.tsBg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 1;
  text-align: center;

  .tsContent {
    margin: 0 auto;
    margin-top: 1.22rem;
    width: 5.6rem;
    height: 8.52rem;
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.20);
    border-radius: 0.12rem;
    overflow: hidden;

    p {
      font-size: 0.24rem;
      color: #19191A;
      margin-top: 0.26rem;
      margin-bottom: 0.1rem;
    }

    img {
      width: 5.2rem;
      height: 3.28rem;
    }
  }

  .closeBtn {
    width: 0.6rem;
    height: 0.6rem;
  }
}

.opacity {
  opacity: 1 !important;
}

.title {
  text-align: center;
  margin-top: -0.3rem;

  img,
  p {
    display: inline-block;
  }

  img {
    width: 0.98rem;
    height: 0.12rem;
    vertical-align: 0.04rem;
  }

  p {
    font-size: 0.28rem;
    color: #323233;
    line-height: 0.24rem;
  }
}

.content {
  width: 94%;
  margin-left: 3%;
  display: flex;
  text-align: center;
  margin-top: -0.5rem;
  margin-bottom: 2rem;

  div {
    flex: 1;
  }

  span {
    font-size: 0.24rem;
    color: #646566;
  }

  img {
    margin-top: 0.2rem;
    width: 1.6rem;
    height: 1rem;
  }
}

.info-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
  text-align: center;
  color: #19191A;
  line-height: .34rem;
  font-size: .24rem;
  background-color: #fff;
  padding: .44rem 0;
  box-sizing: border-box;

  div {
    span {
      color: #2A2AFF;
    }
  }
}

.tips {
  text-align: center;
  font-size: .24rem;
  font-weight: 400;
  color: #19191A;
  line-height: .34rem;

  span {
    color: #2A2AFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/carID-uploading/index.vue